/* План магазина со шкафами. Подложка — картинка плана или сетка;
   шкафы — метки поверх, по долям ширины и высоты. */
.wrap { display: flex; flex-direction: column; gap: 12px; }

.loading { padding: 32px 0; font-size: 14px; color: var(--text2); }

/* ── Планы и действия ── */
.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
}

.tabs { display: flex; flex-wrap: wrap; gap: 6px; }

.tab,
.tabAdd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  font-size: 13.5px;
  color: var(--text2);
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  cursor: pointer;
}

.tab:hover { color: var(--text); border-color: var(--slate-lt); }

.tabActive,
.tabActive:hover {
  color: var(--blue);
  background: var(--blue-lt);
  border-color: color-mix(in srgb, var(--blue) 40%, transparent);
}

:global(html.dark) .tabActive { color: var(--navy-accent); }

.tabCount { font-size: 12px; color: inherit; opacity: .75; font-variant-numeric: tabular-nums; }

.tabAdd { border-style: dashed; }
.tabAdd:hover { color: var(--text); }

.tools { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }

.zoom {
  display: inline-flex;
  align-items: center;
  height: 34px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--card-bg);
}

.zoom button {
  width: 32px;
  height: 100%;
  font-size: 16px;
  color: var(--text);
  background: none;
  border: none;
  cursor: pointer;
}

.zoom button:disabled { color: var(--slate-lt); cursor: default; }
.zoom span { min-width: 44px; font-size: 12.5px; color: var(--text2); text-align: center; font-variant-numeric: tabular-nums; }

.danger { color: var(--err); }
.dangerOn { color: #fff; background: var(--err); border-color: var(--err); }

.nameForm { display: flex; flex-wrap: wrap; gap: 8px; }
.nameForm input { flex: 1 1 260px; }

.error {
  padding: 10px 14px;
  font-size: 13.5px;
  color: var(--err);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

.placingHint {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: var(--text);
  background: var(--blue-lt);
  border: 1px solid color-mix(in srgb, var(--blue) 35%, transparent);
  border-radius: var(--r-sm);
}

.linkButton {
  padding: 2px 0;
  font-size: 13px;
  color: var(--blue);
  background: none;
  border: none;
  cursor: pointer;
}

.linkButton:disabled { color: var(--slate-lt); cursor: default; }
:global(html.dark) .linkButton { color: var(--navy-accent); }

/* ── План и список шкафов ── */
.layout { display: flex; align-items: flex-start; gap: 16px; }

.scroller {
  flex: 1;
  min-width: 0;
  max-height: 75vh;
  overflow: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.frame {
  position: relative;
  min-width: 100%;
  user-select: none;
}

/* Без картинки — сетка, как на миллиметровке */
.grid {
  background-color: var(--card-bg);
  background-image:
    linear-gradient(var(--border) 1px, transparent 1px),
    linear-gradient(90deg, var(--border) 1px, transparent 1px);
  background-size: 5% 8%;
}

.framePlacing { cursor: crosshair; }

.image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

/* В тёмной теме светлая картинка плана приглушена, чтобы не слепила */
:global(html.dark) .image { filter: brightness(.82) contrast(1.05); }

.gridHint {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  font-size: 14px;
  color: var(--text2);
  text-align: center;
  pointer-events: none;
}

/* ── Метка шкафа: подпись и булавка, острие — в точке шкафа ── */
.marker {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  background: none;
  border: none;
  transform: translate(-50%, -100%);
  cursor: pointer;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
}

.markerLabel {
  padding: 3px 9px;
  font-size: 12.5px;
  font-weight: 650;
  line-height: 1.3;
  color: #fff;
  white-space: nowrap;
  background: var(--blue);
  border-radius: var(--r-pill);
  box-shadow: 0 1px 3px rgba(15, 23, 42, .3);
}

.markerPin {
  width: 2px;
  height: 8px;
  background: var(--blue);
}

.markerPin::after {
  content: '';
  display: block;
  width: 8px;
  height: 8px;
  margin: 6px 0 0 -3px;
  background: var(--blue);
  border: 2px solid var(--card-bg);
  border-radius: 50%;
}

.marker:hover .markerLabel,
.marker:focus-visible .markerLabel { background: var(--blue-dark); }
.marker:focus-visible { outline: none; }
.marker:focus-visible .markerLabel { box-shadow: 0 0 0 3px color-mix(in srgb, var(--blue) 40%, transparent); }

.markerMovable { cursor: grab; }
.markerDrag { z-index: 2; cursor: grabbing; opacity: .85; }

/* Пришли «показать на плане» — метка заметна, пока не дочитали */
.markerHighlight { z-index: 1; }
.markerHighlight .markerLabel { animation: pulse 1.2s ease-out 3; }

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 color-mix(in srgb, var(--blue) 60%, transparent); }
  100% { box-shadow: 0 0 0 14px transparent; }
}

@media (prefers-reduced-motion: reduce) {
  .markerHighlight .markerLabel { animation: none; box-shadow: 0 0 0 3px var(--warn); }
}

.side {
  flex: 0 0 260px;
  padding: 14px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.sideTitle {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.sideNote { font-size: 12.5px; font-weight: 400; color: var(--warn); }

.cabList { margin: 0; padding: 0; list-style: none; }

.cabRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0 8px;
  padding: 7px 8px;
  margin: 0 -8px;
  border-radius: var(--r-sm);
}

.cabRowActive { background: var(--blue-lt); }

.cabName { overflow: hidden; font-size: 13.5px; color: var(--text); text-overflow: ellipsis; white-space: nowrap; }
.cabWhere { grid-column: 1; font-size: 12px; color: var(--text2); }
.cabRow .linkButton { grid-column: 2; grid-row: 1 / span 2; align-self: center; }

.sideHelp { margin: 10px 0 0; font-size: 12px; line-height: 1.45; color: var(--text2); }

/* ── Пустое состояние ── */
.emptyBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  max-width: 620px;
  padding: 24px;
  background: var(--card-bg);
  border: 1px dashed var(--border);
  border-radius: var(--r-lg);
}

.emptyTitle { font-size: 17px; font-weight: 600; color: var(--text); }
.emptyText { margin: 0; font-size: 14px; line-height: 1.5; color: var(--text2); }

@media (max-width: 900px) {
  .layout { flex-direction: column; }
  .scroller { width: 100%; }
  .side { flex: none; width: 100%; }
}

@media (max-width: 699px) {
  .tools { width: 100%; }
  .scroller { max-height: 65vh; }
}
